<template>
  <div id="demo-game">
    <div class="game-screen">
      <img draggable="false" v-if="bgSrc" :src="bgSrc" class="background-img" alt="">
      <div class="screen-tools">
        <div class="screen-tools-btns">
          <v-btn
            fab
            class="top-toolbar-btns"
            v-for="i in imgKeys"
            :key="i"
            small
            elevation="0"
            @click="imgIndex = i"
          >
            {{i + 1}}
          </v-btn>
          <v-btn
            fab
            class="top-toolbar-btns"
            small
            elevation="0"
            @click="imgIndex = 10"
          >
            11
          </v-btn>
        </div>
      </div>
      <div class="role-controls">
        <v-btn
          class="role-controls-btns"
          fab
          x-small
          elevation="0"
          @click="btnRoleToggle(-1)"
        >
        </v-btn>
        <v-btn
          class="role-controls-btns"
          fab
          x-small
          elevation="0"
          @click="btnRoleToggle(0)"
        >
        </v-btn>
        <v-btn
          class="role-controls-btns"
          fab
          x-small
          elevation="0"
          @click="btnRoleToggle(1)"
        >
        </v-btn>
      </div>
      <div class="role-img-w role-img-w-1">
        <img draggable="false" class="role-img role-img-1" :src="roleImg1" alt="">
      </div>
      <div class="role-img-w role-img-w-2">
        <img draggable="false" class="role-img role-img-2" :src="roleImg2" alt="">
      </div>
      <div class="q-circle corner-LB hover" :style="corner" v-show="cornerBlock.show" @click="btnRecord">
        <div :style="cornerMicWrapper">
          <v-icon :style="cornerMic" :color="cornerMicInfo.color">mdi-microphone</v-icon>
        </div>
      </div>
      <div class="main-message-box hover" :style="msgBox" v-show="msgBlock.show" @click="btnMsgBox">
        <div class="main-message-content">
          {{msgBlock.text}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { delay } from '@/lib/utils'
import { Howl, Howler } from 'howler'
import { storyStart, storyContinue } from '@/lib/story-api'

export default {
  name: 'DemoGameEmpty',
  computed: {
    cornerMicInfo () {
      return {
        size: this.cornerBlock.size / 2,
        color: '#86BAA1'
      }
    },
    cornerMicWrapper () {
      return {
        display: 'inline-block',
        marginTop: this.cornerBlock.size / 2 - this.cornerMicInfo.size / 3 + 'px',
        marginLeft: this.cornerBlock.size / 7 + 'px'
      }
    },
    cornerMic () {
      return { fontSize: this.cornerMicInfo.size + 'px' }
    },
    corner () {
      const size = this.cornerBlock.size
      return {
        backgroundColor: '#FFD966',
        width: size + 'px',
        height: size + 'px',
        borderRadius: `0 ${size}px 0 0`
      }
    },
    msgBox () {
      return {
        height: this.msgBlock.height + 'px'
      }
    },
    roleImg1 () {
      console.log('getRole1')
      return this.story.displayImgs[0]
    },
    roleImg2 () {
      console.log('getRole1')
      return this.story.displayImgs[1]
    },
    // bgStyle () {
    //   const style = {
    //     backgroundImage: null
    //   }
    //   if (this.bgSrc) {
    //     style.backgroundImage = `url(${this.bgSrc})`
    //   }
    //   return style
    // },
    bgSrc () {
      return this.imgs[this.imgIndex]
    }
  },
  data () {
    return {
      c: {
        STORY_AUDIO: 1
      },
      story: {
        loading: false,

        id: 'PAPP_1',
        current: null,
        roleImgs: [
          'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/role_01',
          'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/role_02'
        ],
        displayImgs: [
          '',
          ''
        ]
      },
      msgBlock: {
        show: false,
        text: '',
        height: 150
      },
      cornerBlock: {
        show: true,
        size: 150
      },
      mic: {
        uploading: false,
        recording: false
      },
      player: {
        playing: false,
        wait: false
      },
      imgIndex: 0,
      imgKeys: new Array(10).fill(0).map((n, i) => i),
      imgs: [
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_01',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_02',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_03',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_04',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_05',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_06',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_07',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_08',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_09',
        'https://voiss-mini.s3-ap-southeast-1.amazonaws.com/demo_210422/imgs/bg_10',
        ''
      ]
    }
  },
  mounted () {
    window.$demo = this
    console.log('page: $demo')
  },
  methods: {
    /**
     * 下一張圖
     */
    btnNext () {
      this.imgIndex += 1
      if (this.imgIndex >= this.imgs.length) {
        this.imgIndex = 0
      }
    },
    /**
     * 上一張圖
     */
    btnBack () {
      this.imgIndex -= 1
      if (this.imgIndex < 0) {
        this.imgIndex = this.imgs.length - 1
      }
    },
    btnRoleToggle (i) {
      const displayImgs = this.story.displayImgs
      if (i < 0) {
        this.story.displayImgs = ['', '']
      } else if (displayImgs[i]) {
        this.story.displayImgs = [...displayImgs]
        this.story.displayImgs[i] = ''
      } else {
        this.story.displayImgs = [...displayImgs]
        this.story.displayImgs[i] = this.story.roleImgs[i]
      }
      console.log('this.story.displayImgs[i]', this.story.displayImgs[i])
    },
    btnMsgBox () {
      this.cornerBlock.show = true
      this.msgBlock.show = false
      this.msgBlock.text = '錄音中....'
    },
    btnRecord () {
      this.cornerBlock.show = false
      this.msgBlock.show = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#demo-game{
  background-color: grey;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.game-screen{
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: #f3e4c7;
  background-size: 100vw 100vh;
}
.main-message-box{
  position: absolute;
  display: inline-flex;
  flex-direction: column;
  left: 5vw;
  bottom: 20px;
  width: 90vw;
  justify-content: center;
  background-color: rgba(100, 100, 100, 0.8);
  border-radius: 15px;
}
.main-message-content{
  display: inline-flex;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}
.hover:hover{
  cursor: pointer;
  opacity: 0.8;
}
.background-img{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.corner-LB{
  position: absolute;
  bottom: 0;
  left: 0;
}
.screen-tools{
  display: flex;
  position: absolute;
  top: 0;
  left: 1%;
  padding-top: 5px;
  padding-bottom: 10px;
  width: 98%;
  justify-content: center;

}
.screen-tools-btns{
  white-space: nowrap;
  overflow-x: auto;
}
.screen-tools-btns{
  /* width */
  &::-webkit-scrollbar {
    max-width: 0px;
    max-height: 0px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
.screen-tools-btns:hover, .screen-tools-btns:active{
  /* width */
  &::-webkit-scrollbar {
    max-width: 2px;
    max-height: 4px;
  }
}

.top-toolbar-btns{
  margin-left: 5px;
  margin-right: 5px;
}

.role-controls{
  position: fixed;
  top: 60px;
  right: 0px;
}
.role-img-w{
  display: inline-block;
  position: absolute;
  top: 20vh;
}
.role-img-w-1{
  left: 7%;
}
.role-img-w-2{
  right: 7%;
}
.role-img{
  width: 40%;
}
</style>
